import React from 'react';
import CardProductHome from '../CardProductHome/CardProductHome';

function ProductsContainerHome() {
  return (
    <section>
      <CardProductHome />
    </section>
  );
}

export default ProductsContainerHome;
